module.exports = __webpack_public_path__ + "static/img/RSG2-12V10A.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RSG2-12V10A.png
// module id = ijKN
// module chunks = 0